import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { Grid, Typography } from '@mui/material';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
import EditIcon from '@mui/icons-material/Edit';
import { IconButton } from '@totalsoft/rocket-ui';
import { Tooltip } from '@mui/material';

export const DocumentScoringGridSummary = ({ t, scoringGrid, onImportFinancialIndicators, onOpenDimensionListModal, disabled, saving, rights, acordionExpanded }) => {
  
  const onClickFinancialIndicators = (event) => {
    //we do stop propagation in order to not afect the acordion expand property when we click on the button
    event.stopPropagation();
    onImportFinancialIndicators(event);
  }

  const onClickOpenDimensionsModal = (event) => {
    //we do stop propagation in order to not afect the acordion expand property when we click on the button
    event.stopPropagation();
    onOpenDimensionListModal(event);
  }

  return (
    <Grid container justifyContent='space-between'>
      <Grid item>
        <Typography color='primary'>
          <strong>{scoringGrid.name}</strong>
        </Typography>

        <Grid container spacing={1} direction='row'>
          <Grid item >
            <Typography color='primary'>
              <strong>{t('DocumentEdit.Scoring.ScoringGrid.Result')}:</strong> <span>{scoringGrid.result}</span>
            </Typography>
          </Grid>
          {scoringGrid.entityType !== 'DOCPARTNER' ? (
            <Grid item xs={12}>
              <Typography color='primary'>
                <strong>{t('DocumentEdit.Scoring.ScoringGrid.FinalScore')}:</strong> <span>{scoringGrid.finalScore}</span>
              </Typography>
            </Grid>
          ) : (
            ''
          )}
        </Grid>
      </Grid>
      {scoringGrid.classifications.some(x=> x?.financialIndicators.length > 0) && acordionExpanded ? (
      <Grid item>
        <IconButton
            onClick={onClickOpenDimensionsModal}
            disabled={rights.readOnlyFull || disabled || saving}
            variant='text'
          >
            <Tooltip title={t('DocumentEdit.Scoring.ScoringIndicator.Dimensions.AddDimension')}>
              <EditIcon />
            </Tooltip>
          </IconButton>

          <IconButton
              onClick={onClickFinancialIndicators}
              disabled={rights.readOnlyFull || disabled || saving}
              variant='text'
            >
            <Tooltip title={t('DocumentEdit.Scoring.ScoringIndicator.Dimensions.FetchDataFromBalanceSheet')}>
              <SystemUpdateAltIcon />
            </Tooltip>
          </IconButton>
      </Grid>
      ) : (
        ''
      )}
    </Grid>
  );

}

DocumentScoringGridSummary.propTypes = {
  t: PropTypes.func.isRequired,
  scoringGrid: PropTypes.object.isRequired,
  onImportFinancialIndicators: PropTypes.func.isRequired,
  onOpenDimensionListModal: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  saving: PropTypes.bool.isRequired,
  rights: PropTypes.object.isRequired,
  acordionExpanded: PropTypes.bool
};

export default compose(withTranslation()(DocumentScoringGridSummary));
